import React, { useEffect } from "react";
import { Box, CircularProgress, Paper } from "@mui/material";
import { Map, InfoWindow, useMap } from "@vis.gl/react-google-maps";
import { MAP_CONFIG } from "../utils/googleMapsUtils";
import { useGoogleMapSearchContext } from "./GoogleMapSearchContext";
import { messages } from "../../../../locales/messages";
import { useTranslation } from "react-i18next";

const MapController: React.FC<{
  center: { lat: number; lng: number };
  zoom: number;
}> = ({ center, zoom }) => {
  const map = useMap();

  useEffect(() => {
    if (!map) return;
    map.panTo(center);
    map.setZoom(zoom);
  }, [map, center, zoom]);

  return null;
};

export const MapPreview: React.FC = () => {
  const { mapCenter, zoom, infoWindow, setInfoWindow, isLoaded } =
    useGoogleMapSearchContext();
  const { t } = useTranslation();
  return (
    <Box sx={{ flex: 1, minWidth: 0, mt: { xs: 3, md: 0 } }}>
      <Box
        component="h3"
        sx={{ fontWeight: 500, fontSize: 18, mb: 1, color: "#f58321" }}
      >
        {t(messages.Map_Preview())}
      </Box>

      <Paper
        variant="outlined"
        sx={{
          p: 0,
          minHeight: 220,
          maxHeight: 320,
          height: 320,
          width: "100%",
          display: "flex",
          alignItems: "stretch",
          overflow: "hidden",
        }}
      >
        {isLoaded ? (
          <Box
            sx={{ width: "100%", height: 320, minHeight: 220, maxHeight: 320 }}
          >
            <Map
              style={MAP_CONFIG.containerStyle}
              defaultCenter={mapCenter}
              defaultZoom={zoom}
              zoomControl={true}
              mapTypeControl={false}
              fullscreenControl={false}
              streetViewControl={false}
            >
              <MapController center={mapCenter} zoom={zoom} />
              {infoWindow ? (
                <InfoWindow
                  position={infoWindow.position}
                  onCloseClick={() => setInfoWindow(null)}
                >
                  <Box>
                    <strong>{infoWindow.name}</strong>
                    <div>{infoWindow.address}</div>
                  </Box>
                </InfoWindow>
              ) : null}
            </Map>
          </Box>
        ) : (
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: 320,
            }}
          >
            <CircularProgress size={32} sx={{ color: "#f58321" }} />
          </Box>
        )}
      </Paper>
    </Box>
  );
};
